<template>
  <div>
    <app-cells>
      <app-input
        @input.native="onClientsSearch"
        v-model="search"
        class="input--300"
        type="search"
        placeholder="Search by name"
        name="search"
      />
    </app-cells>
    <v-client-table
      :data="table.items"
      :columns="table.columns"
      :options="table.options"
      class="table-default"
    >
      <template #h__full_name>
        <div class="table-default__left">Full name</div>
      </template>
      <template #h__before>
        <div class="table-default__left">Before</div>
      </template>
      <template #h__after>
        <div class="table-default__left">After</div>
      </template>
      <template #h__group>
        <div class="table-default__left">Group</div>
      </template>
      <template #count="{ row, index }">{{ index }}</template>
      <template #full_name="{ row }">
        <div class="table-default__left table-default__left--photo">
          <span
            :class="`fflag ff-md fflag-${row.client.citizenship ? row.client.citizenship.code : 'empty'}`"
            v-tooltip="{ content: row.client.citizenship ? row.client.citizenship.name : 'Not provided', placement: 'top-start', offset: 10 }"
          ></span>
          <template v-if="row.client.gender">
            <img v-if="row.client.gender.code === 'male'" src="@/assets/img/male-icon.svg" alt="">
            <img v-if="row.client.gender.code === 'female'" src="@/assets/img/female-icon.svg" alt="">
          </template>
          <img v-else src="@/assets/img/gender-plug-icon.svg" alt="">
          <router-link
            v-if="is_general_manager || is_sales_manager || is_sales_supervisor || is_operations_manager || is_operations_supervisor"
            :to="{ name: 'clients-detail', params: { id: row.client.id } }"
            class="table-default__link-border"
          >
            {{ row.client.full_name }}
          </router-link>
          <span v-else>{{ row.client.full_name }}</span>
          <span v-if="row.age">({{ row.age }} y.o.)</span>
          <img v-if="row.client.category && row.client.category.code === 'tour_leader'" src="@/assets/img/tour-leader-icon.svg" alt="Leader">
          <img v-if="row.birthday" src="@/assets/img/birthday-icon.svg" alt="Birthday">
        </div>
      </template>
      <template #group="{ row }">
        <div class="table-default__controls table-default__left">
          <div class="table-default__photo">
            <img
              :src="getUserAvatar(row.client.manager.crop.crop_url)" alt=""
              v-tooltip="{ content: row.client.manager.full_name, placement: 'top-start', offset: 10 }"
            >
          </div>
          <template v-if="row.client.group">
            <router-link
              v-if="is_general_manager || is_sales_manager || is_sales_supervisor || is_operations_manager || is_operations_supervisor"
              :to="{ name: 'clients-groups-general', params: { id: row.client.group.id } }"
              class="table-default__link-border"
            >
              {{ row.client.group.name }}
            </router-link>
            <div v-else class="table-default__left">{{ row.client.group.name }}</div>
          </template>
          <div v-else class="table-default__left">-</div>
        </div>
      </template>
      <template #before="{ row }">
        <template v-if="row.before">
          <router-link
            :to="{ name: 'reservation-hotels-general', params: { id: row.before.reservation_id } }"
            class="table-default__link-border"
            target="_blank"
          >
            {{ row.before.hotel_name }} ({{ row.before.room_name }})
          </router-link>
          <div v-if="row.before.hotel_management_room_short_name" class="table-default__left">
            Room: {{ row.before.hotel_management_room_short_name }}
          </div>
        </template>
        <template v-else>-</template>
      </template>
      <template #after="{ row }">
        <template v-if="row.after">
          <router-link
            :to="{ name: 'reservation-hotels-general', params: { id: row.after.reservation_id } }"
            class="table-default__link-border"
            target="_blank"
          >
            {{ row.after.hotel_name }} ({{ row.after.room_name }})
          </router-link>
          <div v-if="row.after.hotel_management_room_short_name" class="table-default__left">
            Room: {{ row.after.hotel_management_room_short_name }}
          </div>
        </template>
        <template v-else>-</template>
      </template>
    </v-client-table>
  </div>
</template>

<script>
import { getClimbingGroupsClientsHotels } from '@/http'
import debounce from 'lodash/debounce'

export default {
  name: 'ClimbingGroupsDetailClientsHotels',
  data() {
    return {
      search: '',
      table: {
        items: [],
        columns: [
          'count',
          'full_name',
          'group',
          'before',
          'after',
        ],
        options: {
          headings: {
            'count': '#',
            'full_name': 'Full name',
            'group': 'Group',
            'before': 'Before',
            'after': 'After',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 300,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
  computed: {
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
    is_sales_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_manager')
    },
    is_sales_supervisor() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_supervisor')
    },
    is_operations_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('operations_manager')
    },
    is_operations_supervisor() {
      return this.$store.state.userGroups.map(item => item.code).includes('operations_supervisor')
    },
  },
  created() {
    this.fetchItems()
  },
  methods: {
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
    fetchItems() {
      getClimbingGroupsClientsHotels(this.$route.params.id, { search: this.search })
        .then(res => {
          this.table.items = res.data
        })
    },
    onClientsSearch() {
      this.searchClients(this)
    },
    searchClients: debounce(vm => {
      vm.fetchItems()
    }, 350),
  }
}
</script>
